<div class="grid gap-3 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
  @if (title) {
    <div class="col-span-full text-general-title text-[#1f87bf]">
      Campos de cierre para {{ title | translate }}
    </div>
  }

  @for (field of fieldItem; track fieldItem; let idx = $index) {
    <!-- select catalog -->
    @if (
      (field.componentTypeId == 10 || field.componentTypeId == 17) &&
      hybridForm.controls[field.editClosingFieldId]
    ) {
      <app-input-general-select
        [formControlGeneral]="hybridForm.controls[field.editClosingFieldId]"
        [label]="field.description | translate"
        [placeholder]="field.description | translate"
        [inputSelect]="{ value: 'id', description: 'value' }"
        [arrayData]="field.catalog"
      ></app-input-general-select>
    }

    <!-- input general -->
    @if (
      (field.componentTypeId == 4 || field.componentTypeId == 1) &&
      hybridForm.controls[field.editClosingFieldId]
    ) {
      <app-input-general
        [formControlGeneral]="hybridForm.controls[field.editClosingFieldId]"
        [label]="field.description | translate"
        [placeholder]="field.description | translate"
      ></app-input-general>
    }

    <!-- Input numeric with mask -->
    @if (field.componentTypeId == 16 && hybridForm.controls[field.editClosingFieldId]) {
      <app-input-general
        [formControlGeneral]="hybridForm.controls[field.editClosingFieldId]"
        [label]="field.description | translate"
        [placeholder]="field.description | translate"
        [mask]="'separator'"
        [allowNegativeNumbers]="true"
      ></app-input-general>
    }

    <!-- el catalogo esta en validationRegex separar por | -->
    @if (field.componentTypeId == 2 && hybridForm.controls[field.editClosingFieldId]) {
      <app-input-general-select
        [formControlGeneral]="hybridForm.controls[field.editClosingFieldId]"
        [label]="field.description | translate"
        [placeholder]="field.description | translate"
        [inputSelect]="{ value: '', description: '' }"
        [arrayData]="regexStringToArray(field.validationRegex)"
      ></app-input-general-select>
    }
  }
</div>
